<template>
<div class="chapter">
<div class="inner_page">
<p class="c"><img alt="tmp_648f5cba11b35594391da1bef1608eec_YkgYR9_html_mf0f9958.jpg" class="calibre1" id="graphics1" src="tmp_648f5cba11b35594391da1bef1608eec_YkgYR9_html_mf0f9958.jpg"/></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// tmp_648f5cba11b35594391da1bef1608eec_YkgYR9.ch.fixed.fc.tidied.stylehacked.xfixed_split_000.vue?15792f34